/**
 * CURRENT PROJECT FEATURED PROJECT
 * Last updated: [Date will auto-update when edited]
 * 
 * Update this file to change the current project featured project.
 */

const currentProject = {
  category: "current",
  title: "From bare ground to a complete landscape.",
  images: {
    topLeft: {
      top: "/images/projects/current/rockWallBuilding1A.jpeg",
      bottom: "/images/projects/current/begRockWall1.jpeg",
      topAlt: "Current project bare ground",
      bottomAlt: "Current project crew working"
    },
    bottomLeft: {
      top: "/images/projects/current/emptySpace.PNG",
      bottom: "/images/projects/current/emptySpace.PNG",
      topAlt: "Current project construction",
      bottomAlt: "Current project progress"
    }
  },
  paragraphs: [
    "Perched along a challenging hillside, this project demands a balance of technical skill and artistry.",
    
    "We began by reshaping the terrain for stability, establishing a natural flow for drainage and access. Our team then began building stone retaining walls to frame a wrap-around drive. We're currently setting up the foundation for planting and irrigation work that will follow.",
    
    "Every decision is made with the land's natural character in mind to create a space that feels both intentional and organic. As the project evolves, it's a reminder of what we love most; transforming raw ground into something timeless."
  ]
};

export default currentProject;